const product = {
  product: "Προϊόν", // translated
  products: "Προϊόντα", // translated
  information: "Πληροφορίες", // translated
  additionalInformation: "Επιπλέον πληροφορίες", // translated
  contactUs: "Επικοινωνήστε μαζί μας", // translated
  contactUsText: "Θέλετε να προσαρμόσετε την περιήγησή σας ή έχετε άλλες ερωτήσεις;", // translated
  dropUsAnEmail: "Στείλτε μας ένα email", // translated
  viewLess: "Δείτε λιγότερο", // translated
  viewMore: "Δείτε περισσότερα", // translated
  less: "πιο λιγο", // translated
  more: "περισσότερο", // translated
  highlights: "Καλύτερες στιγμές", // translated
  inclusions: "εγκλείσματα", // translated
  exclusions: "Αποκλεισμοί", // translated
  pleaseWait: "Παρακαλώ περιμένετε...", // translated
  tourType: "Τύπος ξενάγησης", // translated
  search: "Αναζήτηση", // translated
  available: "Διαθέσιμος", // translated
  availableTours: "Διαθέσιμες εκδρομές", // translated
  sortBy: "ΤΑΞΙΝΟΜΗΣΗ ΚΑΤΑ", // translated
  priceLowToHigh: "Τιμή: Χαμηλή προς Υψηλή", // translated
  priceHighToLow: "Τιμή: Υψηλή έως χαμηλή", // translated
  mostPopular: "Δημοφιλέστερος", // translated
  roomOnly: "ΔΩΜΑΤΙΟ ΜΟΝΟ", // translated
  bedAndBreakfast: "ΚΡΕΒΑΤΙ", // translated
  halfBoard: "Ημιδιατροφή", // translated
  fullBoard: "Πλήρης διατροφή", // translated
  allInclusive: "Ολων συμπεριλαμβανομένων", // translated
  viewDetails: "Δείτε λεπτομέρειες", // translated
  close: "Κλείσε", // translated
  at: "Στο", // translated
  person: "πρόσωπο", // translated
  cancellationPolicy: "Πολιτική ακύρωσης", // translated
  cancellationIs: "ακύρωση είναι", // translated
  to: "Προς την", // translated
  bookingRemarks: "Παρατηρήσεις κράτησης", // translated
  totalPrice: "Συνολικό ποσό", // translated
  back: "Πίσω", // translated
  bookNow: "Κάνετε κράτηση τώρα", // translated
  minutes: "Λεπτά", // translated
  visitDuration: "Διάρκεια επίσκεψης", // translated
  itinerary: "Δρομολόγιο", // translated
  airportToHotel: "Αεροδρόμιο προς ξενοδοχείο", // translated
  hotelToAirport: "Ξενοδοχείο προς αεροδρόμιο", // translated
  details: "Λεπτομέριες", // translated
  servicesDetails: "Στοιχεία υπηρεσιών", // translated
  services: "Υπηρεσίες", // translated
  day: "Ημέρα", // translated
  next: "Επόμενο", // translated
  nextStep: "Επόμενο βήμα", // translated
  skip: "Παραλείπω", // translated
  remarks: "Παρατηρήσεις", // translated
  optional: "προαιρετικός", // translated
  guests: "Καλεσμένοι", // translated
  payment: "Πληρωμή", // translated
  pickup: "μαζεύω", // translated
  featuredPackage: "Επιλεγμένο πακέτο", // translated
  flights: "Πτήσεις", // translated
  accommodation: "Κατάλυμα", // translated
  transfers: "Μεταγραφές", // translated
  tours: "Περιηγήσεις", // translated
  experiences: "Εμπειρίες", // translated
  featuredTour: "Επιλεγμένη περιήγηση", // translated
  From: "Από", // translated
  Accommodation: "Κατάλυμα", // translated
  approxDuration: "Περίπου διάρκεια", // translated
  travellerInformation: "Πληροφορίες ταξιδιωτών", // translated
  bookingOverview: "Επισκόπηση κρατήσεων", // translated
  checkout: "Ολοκλήρωση αγοράς", // translated
  paymentFailed: "Η πληρωμή απέτυχε", // translated
  paymentSuccess: "Επιτυχία πληρωμής", // translated
  night: "Νύχτα", // translated
  nights: "Νύχτες", // translated
  viewEscapes: "Προβολή Escape", // translated
  viewExperience: "Προβολή Εμπειρίας", // translated
  escapeType: "Τύπος διαφυγής", // translated
  adultsOnly: "Μόνο ενήλικες", // translated
  totalDuration: "Συνολική Διάρκεια", // translated
  options: "Επιλογές", // translated
  departingAirport: "Αεροδρόμιο αναχώρησης", // translated
  childrenAreNotAllowedInThisTour: "Δεν επιτρέπονται παιδιά σε αυτήν την περιήγηση", // translated
};


export default product;
